var autocomplete = function (url, input, result, code, name, withQuery) {
    $(input).typeahead({
        minLength: 2,
        highlight: true,
        limit: 10
    }, {
        source: function (query, syncResults, asyncResults) {
            var aUrl = withQuery ? url + query : url;
            $.get(aUrl, function (result) {
                if (withQuery) {
                    asyncResults(result);
                } else {
                    var re = new RegExp(query, 'i');
                    var res = result.filter(function(item){
                        return re.test(item[name])
                    });
                    asyncResults(res);
                }
            });
        },
        display: function (item) {
            return item[name];
        },
        async: true
    }).bind('typeahead:select', function (ev, suggestion) {
        if (suggestion) {
            $(result).val(suggestion[code]);
        } else {
            $(result).val("");
        }
    });
};

$(document).ready(function () {
    $('.autocomplete').each(function (index, input) {
        var url = input.getAttribute("url");
        var result = input.getAttribute("result");
        var query = input.getAttribute("withQuery") == "true" ? true : false;
        var code = input.getAttribute("code");
        var name = input.getAttribute("name");
        autocomplete(url, input, $("#" + result), code, name, query);
    });
});